document.addEventListener('DOMContentLoaded', () => {
  const prodFrm = document.querySelector('.product__form');
  console.log('atc script', prodFrm);
  if (!prodFrm) return;

  let isStickyApplied = false;

  function isFormAboveFold(el) {
    const rect = el.getBoundingClientRect();
    return rect.bottom <= 0; // fully above viewport
  }

  function toggleSticky() {
    const aboveFold = isFormAboveFold(prodFrm);

    console.log('aboveFold:', aboveFold);

    if (aboveFold && !isStickyApplied) {
      prodFrm.classList.add('is-sticky');
      console.log('updated sticky');
      isStickyApplied = true;
    } else if (!aboveFold && isStickyApplied) {
      prodFrm.classList.remove('is-sticky');
      console.log('updated not sticky');
      isStickyApplied = false;
    }
  }

  toggleSticky();
  window.addEventListener('scroll', toggleSticky, { passive: true });
  window.addEventListener('resize', toggleSticky);
});
